import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import R from 'ramda'
import {
  Divider,
  Grid,
  Button,
  Accordion,
  Segment
} from 'semantic-ui-react'

import Machines from '_views/machines'
import LineItem from '_views/lineItem'

import {
  getKeyLicensePoolLabel,
  getKeyLicensePoolId
} from '_utils/keys';

import { AUTH_API_URL } from '_constants'
import useCanAdminInstitutionKey from '../../hooks/useCanAdminInstitutionKey'

const getExpires = R.prop('expires_on')
const getExpiresLabel = R.compose(
  R.ifElse(
    x => moment(x).toDate() > new Date(),
    R.always('Expires'),
    R.always(<u>expired</u>)
  ),
  R.propOr('', 'expires_on')
)
const getCreatedOn = R.prop('activated_on')

const getMachines = R.propOr([], 'machines')
const getMachinesLength = R.pathOr(0, ['machines', 'length'])
const SessionAccordion = R.ifElse(
  R.pathSatisfies(R.gt(R.__, 0), ['clave', 'machines', 'length']),
  ({clave, onRemoveKeyMachine}) => (
    <Accordion
      defaultActiveIndex={0}
      styled
      fluid
      exclusive={false}
      panels={[{
        title: `Machines : ${getMachinesLength(clave)} active`,
        content: {
          content: (<Machines machines={getMachines(clave)} fieldName='keyId' objectId={clave._id} onRemoveMachine={onRemoveKeyMachine} />),
          key: 'key_' + clave._id + '_machines'
        }
      }]}
    />
  ),
  () => null
)

const confirmDeleteKey = (onRemove, claveId) => e => {
  if (window.confirm('Remove this key? Users will no longer be able to authorize with it.')) {
    onRemove(claveId)
  }
}

const formatActivatedByUserText = field => R.compose(
  v => v.displayname || v.email || v._id || 'unknown',
  R.pick(['displayname', 'email', '_id']),
  R.defaultTo({}),
  R.prop(field)
)

const Key = ({
  clave,
  onRemoveKey,
  onRemoveKeyMachine
}) => {
  // session_length_min
  const canAdminKey = useCanAdminInstitutionKey(clave);
  const downloadUrl = `${AUTH_API_URL}/institutions/${clave.institution_id}/keys/${clave._id}/download`
  return (
    <Segment
      tertiary={R.propEq('status', 'not_active', clave)}
    >
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column width={ 8 }>
            <LineItem label='License Pool Product' text={ getKeyLicensePoolLabel(clave) } />
            <LineItem label='License Pool ID' text={ getKeyLicensePoolId(clave) } />
            <LineItem label={getExpiresLabel(clave)} text={getExpires(clave)} isDate={true} />
            <LineItem label='Activated by' text={formatActivatedByUserText('activated_by')(clave)} />
            <LineItem label='Created on' text={getCreatedOn(clave)} isDate={true} />
            <LineItem label='Session Length' text={moment.duration(clave.session_length_min, 'minutes').humanize()} />
            <LineItem label='Description' text={clave.description} />
            <br/>
            <LineItem label='Key id' small text={clave._id} />
          </Grid.Column>
          <Grid.Column width={ 8 }>
            {
              canAdminKey ? (
                <Button.Group size='tiny' >
                  <Button content='Download' as='a' href={downloadUrl} />
                  <Button content='Delete' negative onClick={confirmDeleteKey(onRemoveKey, clave._id)} />
                </Button.Group>
              ) : null
            }
            <Divider hidden horizontal />
            {
              canAdminKey ? <SessionAccordion clave={clave} onRemoveKeyMachine={onRemoveKeyMachine} /> : null
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  )
}

Key.propTypes = {
  clave: PropTypes.object.isRequired,
  onRemoveKey: PropTypes.func.isRequired,
  onRemoveKeyMachine: PropTypes.func.isRequired
}

export default Key



// WEBPACK FOOTER //
// ./webAdmin/views/keys/key.js